// Import the Critial JS files needed for every page
import mobileNav from "/js/mobile-nav.js";
import headerNav from "/js/header-nav.js";
import utilsNav from "/js/utils-nav.js";
import searchNav from "/js/search-nav.js";
import { default as popupsInit } from "/js/popups.js";
import { scrollTo } from "/js/utilities.js";

window.popupData = {
	newsletter: {
		success: {
			title: "Thank you",
			message: "Your details are in our database and you are all signed up."
		}
	}
}

const smoothScroll = () => {
	$('a[href*="#"]:not(.js-scroll-done)').each(function() {
		const link = $(this);
		link.on('click', function() {
			if (!link.hasClass('js-scroll-done') && location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
				let target = $(this.hash);
				target = target.length && target || $('[name="' + this.hash.slice(1) + '"]');
				if (target.length) {
					requestAnimationFrame(() => {
						const targetOffset = target.offset().top;
						if (window.site.win.scrollTop() !== targetOffset) {
							scrollTo(targetOffset);
						}
					})

					return false;
				}
			}
		});
		// done
		link.addClass('js-scroll-done');
	});
}

const dynamicLoader = async () => {
	/*
		Files in `/js` subfolders are flattened by Gulp so the paths here dont need `/popup` or similar adding
	*/

	let loadedModules = [];

	// This is an array so you can set the order of being processed 
	// Array is now sorted by 'class' key to avoid duplicating entries 

	// console.log(moduleLookup.sort((a, b) => a.class - b.class);)
	let moduleLookup = [
		{
			class: '.m-read-more',
			filename: 'read-more'
		},
		{
			class: ".addressLookup",
			filename: "lookup"
		},
		{
			class: '.m-property-tabs',
			filename: 'tabs-property'
		},
		{
			class: "#inactivity-logout",
			filename: "inactivity-logout"
		},
		{
			class: "#paymentForm",
			filename: "tigerBay-payment"
		},
		{
			class: "#show-exit-form",
			filename: "exit-form"
		},
		{
			class: ".agent-confirmed-checkbox",
			filename: "booking-flow-agents"
		},
		{
			class: ".alternate",
			filename: "image-paragraph"
		},
		{
			class: ".c-flights-properties__container",
			filename: "flight-details"
		},
		{
			class: ".carousel",
			filename: "carousel"
		},
		{
			class: ".cms",
			filename: "cms"
		},
		{
			class: ".form-checks[data-limit]",
			filename: "refine"
		},
		{
			class: ".js-accordion-trigger",
			filename: "accordion"
		},
		{
			class: ".js-ad-reg-help",
			filename: "ad-reg"
		},
		{
			class: ".js-add-to-wishlist",
			filename: "wishlist-overlay"
		},
		{
			class: ".js-booking-airport-selectors, .js-booking-airport-toggle-action",
			filename: "booking-airports"
		},
		{
			class: ".js-booking-details",
			filename: "booking-details"
		},
		{
			class: ".js-booking-widget",
			filename: "booking-widget"
		},
		{
			class: ".js-dynamic-pager-page",
			filename: "dynamic-pager"
		},
		{
			class: ".js-dynamic-search-replace-applied-filters",
			filename: "applied-filters"
		},
		{
			class: ".js-external",
			filename: "external"
		},
		{
			class: '.cookie-consent',
			filename: 'cookie-consent'
		},
		{
			class: ".js-flight-option",
			filename: "flight-option"
		},
		{
			class: ".js-freeform-search",
			filename: "freeform-search"
		},
		{
			class: ".js-gender-binary-reinforcer",
			filename: "gender-binary-reinforcer"
		},
		{
			class: '.js-toggle-property-title',
			filename: 'toggle-block-property'
		},
		{
			class: '.js-age-checker',
			filename: 'age-checker'
		},
		{
			class: ".js-help-pin",
			filename: "help-pin"
		},
		{
			class: ".js-login-form",
			filename: "login-form"
		},
		{
			class: ".js-max-persons-adults",
			filename: "max-persons"
		},
		{
			class: ".js-nav-link-currency-item",
			filename: "currency"
		},
		{
			class: ".js-newsletter-sign-up",
			filename: "newsletter"
		},
		{
			class: ".js-popup-gallery",
			filename: "photo-gallery"
		},
		{
			class: ".js-profile-form",
			filename: "profile-form"
		},
		{
			class: ".js-right-col",
			filename: "layout-col-height"
		},
		{
			class: ".js-search-map-container",
			filename: "search-map"
		},
		{
			class: ".js-sticky-change-element",
			filename: "sticky-change"
		},
		{
			class: ".js-summary-addition-radio, .js-summary-addition-text",
			filename: "booking-summary"
		},
		{
			class: ".js-tabs-simple",
			filename: "tabs-simple"
		},
		{
			class: ".js-takeover-link",
			filename: "takeover-link"
		},
		{
			class: ".js-toggle-title",
			filename: "toggle-block"
		},
		{
			class: ".m-agents__filters",
			filename: "agents"
		},
		{
			class: ".m-banner",
			filename: "banner"
		},
		{
			class: ".m-banner-hero",
			filename: "carousel"
		},
		{
			class: ".m-blog-snippets",
			filename: "blog-snippets"
		},
		{
			class: ".m-collection",
			filename: "collection"
		},
		{
			class: ".m-home-banner",
			filename: "home-banner"
		},
		{
			class: ".m-map",
			filename: "property-map"
		},
		{
			class: '.m-reviews-fade',
			filename: 'reviews-fade'
		},
		{
			class: '.js-sticky-top-element',
			filename: 'sticky-change'
		},
		{
			class: '.js-countdown-wrapper',
			filename: 'document-countdown'
		},
		{
			class: ".m-marketing-file-collection__name",
			filename: "marketing-file-collections"
		},
		{
			class: '.m-other-destinations-slider',
			filename: 'other-destinations-slider'
		},
		{
			class: '.m-recently-viewed-slider',
			filename: 'recently-viewed-slider'
		},
		{
			class: '.m-rooms-and-suites-slider',
			filename: 'rooms-and-suites-slider'
		},
		{
			class: '.m-reviews-slider',
			filename: 'reviews-slider'
		},
		{
			class: ".m-password__icon",
			filename: "passwords"
		},
		{
			class: ".m-press",
			filename: "press"
		},
		{
			class: ".m-side-nav",
			filename: "side-nav"
		},
		{
			class: ".m-tabs.js-internal",
			filename: "tabs"
		},
		{
			class: ".m-toggle-block",
			filename: "toggle-block"
		},
		{
			class: ".st-accord",
			filename: "accordion"
		},
		{
			class: "[data-recaptcha]",
			filename: "recaptcha"
		},
		{
			class: '.image-search-wrapper',
			filename: 'image-search'
		},
		{
			class: "a[data-analytics-event]",
			filename: "analytics"
		},
		{
			class: '[data-mobile-search-trigger]',
			filename: 'mobile-search-nav'
		},
		{
			//video els
			class: 'a[href*="youtube.com/embed/"], a[href*="youtube.com/watch?v="], [href^="https://vimeo.com/"]',
			filename: 'video'
		},
		{
			class: '.m-agents__reservations__search-btn',
			filename: 'agents-reservation-search'
		},
		{
			class: '.m-documents__download-btn',
			filename: "booking-documents-download"
		}
	];

	let duplicates = []
	let mapping = {}
	moduleLookup.forEach(item => {
		const keyValue = item['class'];
		if (mapping[keyValue]) {
			duplicates.push(item);
		}
		else {
			mapping[keyValue] = true;
		}
	});

	duplicates.length > 0 && console.error(`Duplicate modules loaded - ${JSON.stringify(duplicates)}`);
	mapping = null;

	//First
	moduleLookup.forEach(module => {
		if (document.querySelector(module.class)) {
			loadedModules.push(module.filename)
		}
	});

	//Last
	loadedModules.push(
		'pickers-init',
		'dynamic-search',
		'inactivity-monitor',
		'forms',
		'browser-back-navigation',
		'emergency-message');

	if (loadedModules.length > 0) {

		const importedItems = await Promise.all(
			loadedModules.map(async itemName => {
				try {
					const imported = await import(`/js/${itemName}.js`);
					return imported.default();
				}
				catch (err) {
					console.log(err)
					console.log(`Failed to import item: ${itemName}`);
					return null;
				}
			})
		).then(moduleResult => {
			console.log('All modules loaded')
		})
	}
}

const getPageTranslations = async (language) => {
	const imported = await import(`https://global.localizecdn.com/localize.js`);
	!function(a) { if (!a.Localize) { a.Localize = {}; for (var e = ["translate", "untranslate", "phrase", "initialize", "translatePage", "setLanguage", "getLanguage", "detectLanguage", "getAvailableLanguages", "untranslatePage", "bootstrap", "prefetch", "on", "off", "hideWidget", "showWidget", "getSourceLanguage"], t = 0; t < e.length; t++)a.Localize[e[t]] = function() { } } }(window);

	Localize.initialize({
		key: '5ddc274164735',
		autoApprove: true,
		defaultLanguage: language,
		autodetectLanguage: false
	});
}

document.addEventListener("DOMContentLoaded", () => {

	smoothScroll();
	mobileNav();
	headerNav();
	utilsNav();
	searchNav();
	popupsInit();

	dynamicLoader()

	const documentClass = document.documentElement.classList;
	documentClass.remove('no-js');
	documentClass.add('js');
	window.addEventListener('touchstart', () => {
		documentClass.add('touchevents');
		documentClass.remove('no-touchevents');
	}, { 'once': true })


	window.updateDynamicPhoneNumber = function() {
		if (typeof RulerAnalytics !== 'undefined') {
			RulerAnalytics.updateTelFromCache()
		}
	}
	window.updateDynamicPhoneNumber()

	const language = $('.js-language').data('language')?.toUpperCase();
	if (language && language !== 'EN') {
		getPageTranslations(language);
	}
})
